import * as MutationTypes from "../mutation_types"
import { State, AuthHeaders, PublicAvailability } from "../store_types"
import { afterUseQuestionnairePublicAvailabilitiesCreateAPI, afterUseQuestionnairePublicAvailabilityDestroyAPI, callAfterUseQuestionnairePublicAvailabilityAPI } from "../../api/after_use_questionnaire_public_availabilities"
import { HTTP_STATUS_NO_CONTENT } from "../../api/index"
import { AxiosResponseHeaders } from "axios"

const getDefaultState  = () => {
  return {
    afterUseQuestionnairePublicAvailability: null
  }
}

const afterUseQuestionnairePublicAvailabilities = {
  state: () => getDefaultState(),

  getters: {
    afterUseQuestionnairePublicAvailability (state : State) {
      return state.afterUseQuestionnairePublicAvailability
    }
  },

  actions: {
    createAfterUseQuestionnairePublicAvailability({ dispatch, commit, getters}: { dispatch: (actionName: string, result?: boolean) => void, commit: (mutationType:string, resultData: AxiosResponseHeaders | PublicAvailability) => void, getters: { [key: string]: AuthHeaders | number | Date }}){
      return new Promise<void>((resolve, reject) => {
        afterUseQuestionnairePublicAvailabilitiesCreateAPI(
          getters.authHeaders as AuthHeaders,
          {
            corporationId: getters.selectedCorporationId as number,
            targetMonth: getters.selectedQuestionnaireDate as Date
          },
          // Success
          (headers: AxiosResponseHeaders, status: number) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            if(status == HTTP_STATUS_NO_CONTENT) {
              dispatch("fetchAfterUseQuestionnairesPublished", true)
              dispatch("fetchAfterUseQuestionnairePublicAvailability")
            }
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },

    deleteAfterUseQuestionnairePublicAvailability({ dispatch, commit, getters}: { dispatch: (actionName: string, result: boolean) => void, commit: (mutationType:string, resultData: AxiosResponseHeaders | null) => void, getters: { [key: string]: AuthHeaders}}, afterUseQuestionnairePublicAvailabilityId: number){
      return new Promise<void>((resolve, reject) => {
        afterUseQuestionnairePublicAvailabilityDestroyAPI(
          getters.authHeaders as AuthHeaders,
          afterUseQuestionnairePublicAvailabilityId,
          // Success
          (headers: AxiosResponseHeaders, status: number) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            if(status == HTTP_STATUS_NO_CONTENT) {
              dispatch("fetchAfterUseQuestionnairesPublished", false)
              commit(MutationTypes.ASSIGN_AFTER_USE_QUESTIONNAIRE_PUBLICATION_AVAILABILITY, null)
            }
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },

    fetchAfterUseQuestionnairePublicAvailability({ commit, getters }: { commit: (mutationType:string, resultData: AxiosResponseHeaders | PublicAvailability ) => void, getters: { [key: string]: AuthHeaders | number | Date }}){
      return new Promise<void>((resolve, reject) => {
        callAfterUseQuestionnairePublicAvailabilityAPI(
          getters.authHeaders as AuthHeaders,
          {
            corporationId: getters.selectedCorporationId as number,
            targetMonth: getters.selectedQuestionnaireDate as Date
          },
          // Success
          (headers: AxiosResponseHeaders, publicAvailability: PublicAvailability) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            commit(MutationTypes.ASSIGN_AFTER_USE_QUESTIONNAIRE_PUBLICATION_AVAILABILITY, publicAvailability)
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },

    resetAfterUseQuestionnairePublicAvailabilitiesState ({ commit }: { commit: (mutationType:string) => void }) {
      commit(MutationTypes.RESET_AFTER_USE_QUESTIONNAIRE_PUBLICATION_AVAILABILITIES_STATE)
    },
  },

  mutations: {
    [MutationTypes.ASSIGN_AFTER_USE_QUESTIONNAIRE_PUBLICATION_AVAILABILITY](state: State, afterUseQuestionnairePublicAvailability: PublicAvailability) {
      state.afterUseQuestionnairePublicAvailability = afterUseQuestionnairePublicAvailability
    },
    [MutationTypes.RESET_AFTER_USE_QUESTIONNAIRE_PUBLICATION_AVAILABILITIES_STATE](state: State) {
      Object.assign(state, getDefaultState())
    },
  }
}

export default afterUseQuestionnairePublicAvailabilities
